import request from '@/config/axios'

// AI 技能 VO
export interface AiSkillVO {
  id: number
  skillCode: string
  skillName: string
  description?: string
  skillContent?: string
  status: number
  remark?: string
  createTime?: Date
}

// AI 技能 API
export const SkillApi = {
  // 获得技能分页
  getSkillPage: async (params: any) => {
    return await request.get({ url: '/ai/skill/page', params })
  },

  // 获得技能详情
  getSkill: async (id: number) => {
    return await request.get({ url: '/ai/skill/get?id=' + id })
  },

  // 创建技能
  createSkill: async (data: AiSkillVO) => {
    return await request.post({ url: '/ai/skill/create', data })
  },

  // 更新技能
  updateSkill: async (data: AiSkillVO) => {
    return await request.put({ url: '/ai/skill/update', data })
  },

  // 删除技能
  deleteSkill: async (id: number) => {
    return await request.delete({ url: '/ai/skill/delete?id=' + id })
  },

  // 获得技能下拉列表
  getSkillSimpleList: async () => {
    return await request.get({ url: '/ai/skill/simple-list' })
  }
}
